import { Grid, Box } from "@mui/material";
import SectionHeader from "../../components/SectionHeader";
import PageLoader from "../../components/PageLoader";
import { useInfo } from "../../hooks/useInfo";
import { sanitizeHtml } from "../../utils/safeHtml";
import styles from "./styles";

const AboutUsPage = () => {
  const { data: info, isLoading, error } = useInfo();

  return (
    <PageLoader isLoading={isLoading} error={error} errorMessage="Failed to load about us information">
      <Grid container justifyContent={"center"} pb={10}>
        <SectionHeader
          title={"About Us"}
          description={"Below you can find information about us"}
        />
        <Grid item xs={10} lg={8}>
          {info?.description ? (
            <Box
              sx={styles.descriptionSx}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(info.description) }}
            />
          ) : null}
        </Grid>
      </Grid>
    </PageLoader>
  );
};

export default AboutUsPage;
